<template>
    <div class="box">
        <div><SearchOutlined /></div>
        <div>
            <a-input-search
                v-model:value="value"
                placeholder="农产品/农机/行业/课程时间"
                @search="onSearch"
            />
        </div>
        <div><a-badge dot><BellOutlined /></a-badge></div>
    </div>
</template>

<script>
import SearchOutlined from '@ant-design/icons-vue/lib/icons/SearchOutlined'
import BellOutlined from '@ant-design/icons-vue/lib/icons/BellOutlined'
import { ref } from 'vue'
export default {
    name: "tool",
    setup() {
        const value = ref('')
        const onSearch = searchValue => {
            console.log('use value', searchValue);
            console.log('or use this.value', value.value);
        }
        return {
            value,
            onSearch
        }
    },
    components: {
        SearchOutlined,
        BellOutlined
    }
}
</script>

<style scoped lang="stylus">
    .box {
        width 100%
        height 35px
        line-height 35px
        margin 10px 0
        display flex
        flex-wrap nowrap
        justify-content space-between
        text-align center
    }
    .box div:nth-child(1) {
        width 16.5%
        height 35px
        font-size 20px
    }
    .box div:nth-child(2) {
        width 67%
        height 35px
        line-height 35px
    }
    .box div:nth-child(2) >>> .ant-input-affix-wrapper {
        border-color #F6F6F6
        background-color #F6F6F6
    }
    .box div:nth-child(2) >>> .ant-input-affix-wrapper > input.ant-input {
        background-color #F6F6F6
    }
    .box div:nth-child(3) {
        width 16.5%
        height 35px
        font-size 20px
    }
    .box div:nth-child(3) >>> .ant-badge {
        font-size 20px
    }
</style>